module.exports = __webpack_public_path__ + "img/qrcode-preview.fe791445.png";